import React from 'react'
/**
 * table中多行显示容器
 */
const TableNewlineView = (props) => {
    if (!props.children || !props.children.length) return null
    const context = props.children.map(e => {
        if (e !== 0 && !e) return '-'
        return e
    }).join('\n')
    return (
        <pre style={{marginBottom: 0}}>{context}</pre>
    )
}

export default TableNewlineView


// WEBPACK FOOTER //
// ./src/components/TableNewlineView/index.jsx